import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { Payment } from '../loan/Payments';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateMultipleFeesPaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createMultipleFeesPayment'),
  payment: Payment,
  feeIds: z.array(zodBrandedUuid<FeeId>()).min(1),
  disableEmail: z.boolean().optional(),
});
export type CreateMultipleFeesPaymentEvent = z.infer<typeof CreateMultipleFeesPaymentEvent>;
